var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrulyPaperLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 57.311 78.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16639",
    "data-name": "Group 16639",
    transform: "translate(-1161 -5634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32216",
    "data-name": "Path 32216",
    d: "M56.356,2H24.119a1.79,1.79,0,0,0-1.266.525L8.525,16.852A1.79,1.79,0,0,0,8,18.119V71.848A8.965,8.965,0,0,0,16.955,80.8h39.4a8.965,8.965,0,0,0,8.955-8.955V10.955A8.965,8.965,0,0,0,56.356,2Zm5.373,69.848a5.379,5.379,0,0,1-5.373,5.373h-39.4a5.379,5.379,0,0,1-5.373-5.373V18.86L24.86,5.582h31.5a5.379,5.379,0,0,1,5.373,5.373ZM24.119,23.492H15.164a1.791,1.791,0,1,1,0-3.582h8.955a1.792,1.792,0,0,0,1.791-1.791V9.164a1.791,1.791,0,0,1,3.582,0v8.955A5.379,5.379,0,0,1,24.119,23.492Z",
    transform: "translate(1153 5632)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32217",
    "data-name": "Path 32217",
    d: "M36.656,30.656A14.328,14.328,0,1,0,50.983,44.983,14.344,14.344,0,0,0,36.656,30.656Zm7.164,14.328a1.79,1.79,0,0,1-1.791,1.791H31.283a1.791,1.791,0,0,1,0-3.582H42.028A1.79,1.79,0,0,1,43.819,44.983Z",
    transform: "translate(1153 5632)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrulyPaperLess);
export default __webpack_public_path__ + "static/media/TrulyPaperLess.fdcda50f19a23cca23e688bf70d89c71.svg";
export { ForwardRef as ReactComponent };